const userPinnedResourcesQueryKeys = {
  userPins: (board, filter) => {
    const queryKey = [
      "user-pins",
      board || null
    ];
    if (filter) {
      queryKey.push(filter);
    }
    return queryKey;
  }
};

export { userPinnedResourcesQueryKeys };
//# sourceMappingURL=userPinnedResourcesQueryKeys.js.map
